export default __webpack_public_path__ + "static/media/ursumeditamasgrande.fb3d62f4.webp";